export const ASSESORS = [
  'fonoavisos@comercio.com.pe'
];

export const TERM_AND_CONDITIONS = [
  {
    text: 'Términos y Condiciones',
    link: '/terminos-y-condiciones'
  },
  {
    text: 'Políticas de Publicación',
    link: '/politicas-de-publicacion'
  },
  {
    text: 'Políticas de Privacidad',
    link: '/politicas-de-privacidad'
  },
  {
    text: 'Cláusula de Consentimiento para Fines Adicionales',
    link: '/clausula-de-consentimiento-para-fines-adicionales'
  }
];
